import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { Link } from 'gatsby-plugin-react-intl';

export const Category = styled.div`
  margin-bottom: 1rem;
`;

export const Content = styled.ul`
  li {
    padding: 1rem 0rem;
    border-bottom: 1px solid ${themeGet('colors.border-grey')};
    a {
      display: block;
    }
  }
  li:not(:first-child) {
    margin-top: 0;
  }
  p {
    font-weight: ${themeGet('fontWeights.normal')};
    font-size: 16px;
  }
  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    p {
      font-size: 18px;
    }
  }
`;

export const StyledLink = styled(Link)`
  &:hover {
    p {
      color: ${themeGet('colors.pc-red', '#E1251B')};
    }
  }
`;
